import { render, staticRenderFns } from "./ListItem.vue?vue&type=template&id=2d544e5e&scoped=true"
import script from "./ListItem.vue?vue&type=script&lang=ts"
export * from "./ListItem.vue?vue&type=script&lang=ts"
import style0 from "./ListItem.vue?vue&type=style&index=0&id=2d544e5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d544e5e",
  null
  
)

export default component.exports